<template>
  <div class="coupon-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link
                    :to="{ name: 'coupon_external_list' }"
                    class="float-left mr-1 main-link"
                    >{{ $t("coupon.child_coupon") }}</router-link
                  >
                  / {{ $t("coupon.import_history") }}
                </h3>
              </strong>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <!-- Basic information -->
          <b-card header-tag="header" footer-tag="footer" class="header">
            <b-form class="row">
              <b-col cols="12">
                <div class="form-group row">
                  <div class="col-sm-3">
                    <multiselect
                      v-model="parentObj"
                      v-bind:placeholder="$t('coupon.parent_coupon_code')"
                      label="text"
                      track-by="value"
                      @input="parentChange()"
                      :options="customCouponParentData"
                      v-bind:selectLabel="$t('menu.select_label')"
                      v-bind:deselectLabel="$t('menu.select_remove')"
                      v-bind:selectedLabel="$t('menu.selected')"
                    />
                  </div>
                  <div class="col-sm-4">
                    <date-picker-input
                      class="form-control col-sm-5 float-left h-40-px"
                      name="date"
                      type="date"
                      :placeholder="$t('coupon.imported_date')"
                      value="imported_date"
                      :showMask="false"
                      :border="true"
                      :isShowIcon="true"
                      :isCanClearDate="true"
                      :isClear="isClear"
                      :hasPicker="true"
                      :isReturnWrongFormat="true"
                      formatInput="DD-MM-YYYY"
                      formatOutput="DD-MM-YYYY"
                      :change="e => (imported_date = e)"
                    />
                    <button
                      type="button"
                      class="btn bg-main border-radius-4px refresh-btn"
                      @click="clearFilter"
                    >
                      <span class="fa fa-refresh"></span>
                      <span>{{ $t("common.refresh") }}</span>
                    </button>
                    <div
                      v-if="isProcessing"
                      class="spinner-border text-success icon-inprocessing"
                      role="status"
                    ></div>
                    <span v-if="isProcessing" class="text-inprocessing">{{
                      $t("common.import_in_progress")
                    }}</span>
                  </div>
                </div>
                <!-- Start of Data table session -->
                <div>
                  <table class="table">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          v-for="item in dataTable.fields"
                          :key="item.id"
                        >
                          <span v-if="item.label != null">{{
                            $t("coupon." + item.label)
                          }}</span>
                          <span v-if="item.label == null">{{
                            $t("coupon." + item.name)
                          }}</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="dataTable.items.length == 0">
                        <td
                          class="text-center"
                          :colspan="dataTable.fields.length + 2"
                        >
                          {{ $t("message.no_data") }}
                        </td>
                      </tr>
                      <tr v-for="item in dataTable.items" :key="item.id">
                        <td
                          scope="row"
                          class="text-left"
                          v-for="field in dataTable.fields"
                          :key="field.id"
                        >
                          <span
                            v-if="!field.isBtn && field.render != null"
                            v-html="field.render(item[field.name], item)"
                          ></span>
                          <span v-if="!field.isBtn && field.render == null">
                            {{ item[field.name] }}
                          </span>
                          <div
                            class="download-div"
                            v-if="
                              field.isBtn &&
                                field.render != null &&
                                field.render(item[field.name], item) != null
                            "
                            @click="
                              downloadMissedCodesFile(
                                field.render(item[field.name], item)
                              )
                            "
                          >
                            <span class="download-icon"> </span>
                            <span class="download-title"
                              >{{ $t("coupon.download_error_file") }}
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- End of Data table session -->

                <!-- Start of paginate session -->
                <b-row>
                  <b-col col lg="3" class="col-inline">
                    <span>{{ $t("coupon.rows_per_page") }}</span>
                    <b-form-select
                      v-model="dataTable.perPage"
                      :options="[10, 20, 50, 100]"
                      class="mb-3 select-page"
                    />
                  </b-col>
                  <b-col col lg="7"> </b-col>
                  <b-col class="text-right">
                    <span>{{
                      $t("message.datatable_coupon_import", {
                        from:
                          (dataTable.currentPage - 1) * dataTable.perPage + 1,
                        to:
                          dataTable.currentPage * dataTable.perPage >
                          dataTable.total
                            ? dataTable.total
                            : dataTable.currentPage * dataTable.perPage,
                        total: dataTable.total
                      })
                    }}</span>
                    <span class="prev-icon" @click="prevPage"></span>
                    <span class="next-icon" @click="nextPage"></span>
                  </b-col>
                </b-row>
                <!-- Start of paginate session -->
              </b-col>
            </b-form>
          </b-card>
          <!-- Basic information -->
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import MaskedInput from "vue-text-mask";
import Multiselect from "vue-multiselect";
import DatePickerInput from "@/components/Partials/DatePickerInput";
import moment from "moment";

let vm = null;
const IN_COMPLETE = "incomplete";
const COMPLETED = "completed";
const DATEFORMAT = "MMMM DD, YYYY hh:mm A";
const COUPONPARENTDATA = "couponParentData";
const LOADING = "loading";
const NONE = "none";
const BLOCK = "block";
const LANG = "lang";
const VUE_SESSION_KEY = "vue-session-key";
const CONFIG_BASE_ID = "config.base.id";

//Const Column
const PARENT_COUPON_ID = "parent_coupon_id";
const PARENT_COUPON_CODE = "parent_coupon_code";
const IMPORTED_FILE_NAME = "imported_file_name";
const TOTAL_CODES = "total_codes";
const DUPLICATED_NUMBER = "duplicated_number";
const ADDED_NUMBER = "added_number";
const STATUS = "status";
const DOWNLOAD = "download";
const IMPORTER_EMAIL = "importer_email";
const IMPORTED_DATE = "imported_date";
const CREATED_DATE = "created_at";
const UUID = "uuid";
const IN_PROGRESS = "in_progress";
const FIRST_PAGE = 1;
const intervalTime = 30000;
const clearIntervalTime = 1000;
const clearFilterTime = 100;
const expredTime = 10;
let incompleteList = [];
let checkLastImport = null;
let params = "";

export default {
  components: {
    MaskedInput,
    Multiselect,
    DatePickerInput
  },
  data: function() {
    return {
      clientID: localStorage.getItem("clientID"),
      couponParentData: {},
      customCouponParentData: [],
      coupon_id: null,
      parentObj: "",
      imported_date: "",
      parent_coupon_id: "",
      client_id: 0,
      isProcessing: false,
      isClear: false,
      isLoadingCouponParent: false,
      languages: Object.keys(this.$i18n.messages),
      dataTable: {
        items: [],
        fields: [
          {
            name: PARENT_COUPON_CODE,
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data === null) {
                return "";
              }
              return data;
            }
          },
          {
            name: IMPORTED_FILE_NAME,
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data === null) {
                return "";
              }
              return data;
            }
          },
          {
            name: TOTAL_CODES,
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data === null) {
                return "";
              }
              return data;
            }
          },
          {
            name: DUPLICATED_NUMBER,
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data === null) {
                return "";
              }
              return data;
            }
          },
          {
            name: ADDED_NUMBER,
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data === null) {
                return "";
              }
              return data;
            }
          },
          {
            name: STATUS,
            filter: false,
            sort: false,
            render: (data, row) => {
              if (row === null) {
                return "";
              }
              return row[TOTAL_CODES] ===
                row[DUPLICATED_NUMBER] + row[ADDED_NUMBER]
                ? vm.$t(`coupon.${COMPLETED}`)
                : null === row[DOWNLOAD] &&
                  row[TOTAL_CODES] > row[DUPLICATED_NUMBER] + row[ADDED_NUMBER]
                ? vm.$t(`coupon.${IN_PROGRESS}`)
                : vm.$t(`coupon.${IN_COMPLETE}`);
            }
          },
          {
            name: DOWNLOAD,
            isBtn: true,
            filter: false,
            sort: false,
            render: (data, row) => {
              return data;
            }
          },
          {
            name: IMPORTER_EMAIL,
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data === null) {
                return "";
              }
              return data;
            }
          },
          {
            name: CREATED_DATE,
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data === null) {
                return "";
              }
              let datetime = vm.convertUTCToClientTime(data);
              if (datetime != "") {
                return datetime.format(DATEFORMAT);
              }
              return data;
            }
          }
        ],
        sort: {
          field: "id",
          type: "desc"
        },
        currentPage: 1,
        total: 0,
        perPage: 10,
        source: null
      }
    };
  },
  methods: {
    parentChange() {
      if (vm.parentObj) {
        vm.coupon_id = vm.parentObj.value;
      } else {
        vm.coupon_id = vm.parentObj;
      }
    },
    getCouponParent() {
      let params = "";
      vm.axios.coupon.getCouponParent(params, function(response) {
        let langs = vm.languages;
        for (let l in langs) {
          let lang = langs[l];
          vm.couponParentData[lang] = [];
          for (let i in response.data.data.items) {
            let item = {};
            item["text"] = response.data.data.items[i].code;
            item["value"] = response.data.data.items[i].id;
            vm.couponParentData[lang].push(item);
          }
        }
        vm.isLoadingCouponParent = true;
        vm.$forceUpdate(COUPONPARENTDATA);
        vm.$bus.$emit(LOADING, NONE);
      });
    },
    downloadMissedCodesFile(uuid) {
      vm.axios.coupon.downloadMissedCodesFile(uuid);
    },
    refreshData() {
      let _data = {
        page: vm.dataTable.currentPage,
        limit: vm.dataTable.perPage,
        sort_field: vm.dataTable.sort.field,
        sort_type: vm.dataTable.sort.type,
        client_id: vm.client_id
      };

      if (vm.coupon_id) {
        _data[PARENT_COUPON_ID] = vm.coupon_id;
      }
      if (!vm._.isEmpty(vm.imported_date)) {
        _data[IMPORTED_DATE] = vm.imported_date.trim();
      }

      params = "";
      for (let key in _data) {
        params += key + "=" + _data[key] + "&";
      }

      params = params.slice(0, -1);
      vm.axios.coupon.getImportHistories(params, response => {
        let items = vm._.get(response, "data.data.items", []);
        let total = vm._.get(response, "data.data.pagination.total", 0);
        let isNotListen =
          items[0] &&
          ((incompleteList[items[0][UUID]] === items[0][ADDED_NUMBER] &&
            items[0][ADDED_NUMBER] < items[0][TOTAL_CODES]) ||
            items[0][ADDED_NUMBER] ===
              items[0][TOTAL_CODES] + items[0][DUPLICATED_NUMBER]);

        items = items.map(item => {
          item[DOWNLOAD] = vm.showBtnDownload(items, item);
          return item;
        });

        vm.dataTable.items = items;
        vm.dataTable.total = total;

        if (!isNotListen) {
          vm.listenLastImport();
        }

        vm.$bus.$emit(LOADING, NONE);
      });
    },
    listenLastImport() {
      if (
        vm.dataTable.currentPage === FIRST_PAGE &&
        vm.dataTable.items[0] &&
        vm.isNotExpired(vm.dataTable.items[0])
      ) {
        clearInterval(checkLastImport);
        checkLastImport = setInterval(() => {
          vm.axios.coupon.getImportHistories(params, response => {
            let firstRow = vm._.get(response, "data.data.items")[0];
            if (
              incompleteList[firstRow[UUID]] === firstRow[ADDED_NUMBER] ||
              firstRow[ADDED_NUMBER] === firstRow[TOTAL_CODES]
            ) {
              setTimeout(() => {
                clearInterval(checkLastImport);
              }, clearIntervalTime);
            }

            if (firstRow) {
              let newItems = vm._.clone(vm.dataTable.items);
              firstRow[DOWNLOAD] = vm.showBtnDownload(newItems, firstRow);
              newItems[0] = firstRow;
              vm.dataTable.items = newItems;
            }
          });
        }, intervalTime);
      }
    },
    prevPage() {
      if (vm.dataTable.currentPage > 1) {
        vm.dataTable.currentPage--;
      }
    },
    nextPage() {
      vm.isProcessing = false;
      clearInterval(checkLastImport);
      if (
        vm.dataTable.currentPage <
        Math.ceil(vm.dataTable.total / vm.dataTable.perPage)
      ) {
        vm.dataTable.currentPage++;
      }
    },
    isNotExpired(row) {
      let now = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
      let createdAt = vm
        .convertUTCToClientTime(row[CREATED_DATE])
        .add(expredTime, "minutes");

      return createdAt > now;
    },
    clearFilter() {
      vm.parentObj = "";
      vm.coupon_id = null;
      vm.imported_date = "";
      vm.isClear = true;
      setTimeout(() => {
        vm.isClear = false;
      }, clearFilterTime);
      vm.refreshData(true);
    },
    showBtnDownload(items, row) {
      if (row[TOTAL_CODES] === row[ADDED_NUMBER] + row[DUPLICATED_NUMBER]) {
        if (items[0] && items[0][UUID] === row[UUID]) {
          vm.isProcessing = false;
        }

        return null;
      }
      if (row[CREATED_DATE]) {
        if (vm.isNotExpired(row) && items[0] && items[0][UUID] === row[UUID]) {
          if (
            undefined !== incompleteList[row[UUID]] &&
            incompleteList[row[UUID]] === row[ADDED_NUMBER]
          ) {
            vm.isProcessing = false;
            return row[TOTAL_CODES] ===
              row[DUPLICATED_NUMBER] + row[ADDED_NUMBER]
              ? null
              : row[UUID];
          } else {
            vm.isProcessing =
              row[TOTAL_CODES] > row[DUPLICATED_NUMBER] + row[ADDED_NUMBER];
            incompleteList[row[UUID]] = row[ADDED_NUMBER];
          }
          return null;
        }
      }
      return row[UUID];
    }
  },
  watch: {
    "dataTable.currentPage": function(val) {
      vm.refreshData();
    },
    "dataTable.perPage": function(val) {
      if (
        vm.dataTable.currentPage * vm.dataTable.perPage >
        vm.dataTable.total
      ) {
        vm.dataTable.currentPage = 1;
      }

      vm.refreshData();
    },
    coupon_id: function(val) {
      vm.dataTable.currentPage = 1;
      vm.refreshData();
    },
    imported_date: function(val) {
      vm.dataTable.currentPage = 1;
      vm.refreshData();
    },
    isLoadingCouponParent: function(val) {
      vm.refreshData();
    }
  },
  created: function() {
    vm = this;
    vm.client_id = vm._.get( JSON.parse(localStorage.getItem(VUE_SESSION_KEY)), CONFIG_BASE_ID, 0);
    vm.$bus.$emit(LOADING, BLOCK);
    vm.getCouponParent();
  },
  updated: function() {
    if (vm.couponParentData[vm.$session.get(LANG)] !== undefined) {
      vm.customCouponParentData = vm.couponParentData[vm.$session.get(LANG)];
    }
  },
  mounted: function() {}
};
</script>

<style>
.coupon-form input,
.coupon-form textarea,
.coupon-form select,
.coupon-form .multiselect__tags {
  border-radius: 4px !important;
}

.multiselect__tags {
  border-radius: 0 !important;
}
.coupon-form .btn-secondary {
  border-radius: 3px;
}

.coupon-form .form-check:after,
.coupon-form .form-check:before {
  content: " ";
  display: table;
  content: "";
  line-height: 0;
}

.coupon-form .form-check input[type="checkbox"] {
  opacity: 0;
  z-index: 1;
  cursor: pointer;
}

.coupon-form .form-check label {
  min-height: 20px;
  padding-left: 15px;
  cursor: pointer;
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: normal;
  vertical-align: middle;
  position: relative;
}

.coupon-form .form-check label::before {
  border-radius: 50%;
  content: "";
  display: inline-block;
  position: absolute;
  width: 20px;
  height: 20px;
  left: 0;
  margin-left: -10px;
  border: 1px solid #cccccc;
  background-color: #fff;
  -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
}

.coupon-form .form-check input[type="checkbox"]:checked + label::before {
  background-color: #0086ff;
  border-color: #0086ff;
}

.coupon-form .form-check input[type="checkbox"]:checked + label::after {
  font-family: "FontAwesome";
  content: "\f00c";
  color: #fff;
}

.coupon-form .form-check label::after {
  display: inline-block;
  position: absolute;
  width: 16px;
  height: 16px;
  left: 0;
  top: 0;
  margin-left: -10px;
  padding-left: 4px;
  padding-top: 1px;
  font-size: 12px;
  color: #0086ff;
}

.coupon-form #customize-field .col-sm-10 {
  padding-left: 8px;
}

.coupon-form .form-check-inline {
  margin-right: 1rem;
}

.coupon-form .modal-lg {
  max-width: 95%;
  margin-top: 0;
}

.coupon-form .modal-body {
  padding: 0 1rem;
}

.coupon-form .padding-none {
  padding: 0;
}

.applicable-store label span {
  width: 48px;
}

.applicable-store select {
  margin-right: 20px;
}

.img-min-height {
  min-height: 0 !important;
}

.multiselect__placeholder {
  margin-bottom: 6px !important;
}

.not_apply_date .mx-input-append {
  display: none !important;
}
.not_apply_date .mx-calendar {
  width: 400px !important;
}
.not_apply_date .mx-calendar-header {
  width: 100% !important;
}
.not_apply_date .mx-calendar-content {
  width: 100% !important;
  height: 100% !important;
}
.not_apply_date .mx-time-list {
  height: 225px;
}
</style>

<style scoped>
#application_result_content .gray-background {
  border-radius: 0;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

#application_result_content .gray-light-background {
  border-radius: 0;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.payment-methods {
  padding: 0 !important;
}

.payment-methods .form-group {
  padding: 10px 15px 0 15px;
  margin-bottom: 5px;
}

.payment-methods .form-group:last-child {
  margin-bottom: 15px;
}

.payment-methods .form-check {
  margin-left: 15px;
}

.business-hours .form-check {
  padding-right: 15px;
}

.business-hours {
  display: inline-flex;
  vertical-align: middle;
}

.size-circle {
  margin-left: 5px;
}

.sl-discount-unit,
.ipt-discount-unit {
  min-height: 40px;
}

.delete-csv {
  background: transparent;
  color: #0086ff;
  border: none;
  font-size: 20px;
}

/*input file */
.file-select > .select-button {
  padding: 7px;
  color: white;
  border-radius: 0.2rem;
  text-align: center;
  font-weight: bold;
  background: #0086ff !important;
  border-color: #0086ff !important;
  cursor: pointer;
  margin-top: 3px;
}

.file-select > input[type="file"] {
  display: none;
}

.applicable-store {
  display: inline-flex;
}

.applicable-store input {
  margin-top: 5px;
}

.switch-custom {
  max-width: 5.3%;
}

.table-bordered {
  margin-top: 10px;
}

.table-bordered thead {
  background-color: #e1e6eb;
}

.table-bordered tbody {
  background-color: #f4f6f8;
}

.table-bordered th {
  border: none;
}

.table-bordered .center {
  text-align: center;
}

.col-sm-2-custom {
  flex: 0 0 12.66667%;
  margin-top: 2px;
  text-align: center;
}

.col-sm-2-custom-display-inline {
  flex: 0 0 12.66667%;
  margin-top: 2px;
  text-align: center;
  display: inline-flex;
}

.coupon-form .btn-save {
  float: right;
  margin-right: 22px;
}

.coupon-form .switch.switch-icon {
  margin-top: 5px;
}

.coupon-form .header-custom {
  margin-top: 15px;
}

.coupon-form .header-custom-switch {
  margin-top: 5px;
  margin-bottom: 0;
}

.coupon-form .header-custom-switch .uppercase {
  display: inline-flex;
}

.coupon-form .header-custom-switch .col-form-label {
  text-align: right;
}

.coupon-form .header-custom-switch .active {
  float: right;
}

.coupon-form div.header,
.coupon-form .header .card-header {
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}

.coupon-form .card-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 7.75px;
  border-top: none;
  margin-top: 1.5rem;
  z-index: 999;
}

.coupon-form .add-more {
  padding-left: 0;
}

.gray-background .form-control {
  border: 1px solid gray;
}

.gray-background {
  background: #e1e6eb;
  padding: 15px;
  border-radius: 5px;
  border: 1px solid #dde2e8;
}

.gray-light-background {
  background: #f4f6f8;
  padding: 15px;
  border-radius: 5px;
  border: 1px solid #dde2e8;
}

.gray-background .row {
  margin-bottom: 0px;
}

.remark .btn-danger {
  margin-top: 7px;
  background-color: #fff;
}

.gray-light-background .btn-danger,
.table-bordered .btn-danger {
  background-color: #f4f6f8;
}

.table-bordered .btn-danger {
  margin-top: 4px;
}

.gray-background .btn-danger {
  background-color: #e1e6eb;
}

.gray-background .btn-danger .fa,
.gray-light-background .btn-danger .fa,
.remark .btn-danger .fa,
.table-bordered .btn-danger .fa {
  color: #0086ff;
  font-size: 20px;
}

.gray-background .col-sm-10,
.gray-light-background .col-sm-10,
.gray-light-background .col-sm-5 {
  padding-left: 5px;
}

.margin-top20 {
  margin-top: 20px;
}

.margin-bottom10 {
  margin-bottom: 10px;
}

.clear-both {
  margin-bottom: 15px;
}

.card {
  margin-bottom: 0;
}

.coupon-image {
  margin: 0;
  padding: 0;
  display: inline-flex;
}

.coupon-properties {
  display: -webkit-inline-box;
  position: relative;
  margin: 0;
  padding: 0;
}

.coupon-image img {
  width: 100%;
}

.coupon-properties legend {
  width: auto;
  resize: both;
}

.coupon-properties .check-is-member {
  max-width: 16%;
}

.preview-image {
  width: 100%;
}

.switch-enable-link {
  padding: 0.375rem 0.75rem;
}

.upload-text {
  margin-left: 22px;
}

.file-upload-text {
  margin-left: 25px;
  margin-right: 5px;
}
.table thead th {
  border-top: 0px solid;
  border-bottom: #c4c4c4 2px solid !important;
  margin: 16px;
}

tbody > tr {
  border-top: #c4c4c4 2px solid;
  border-bottom: #c4c4c4 2px solid;
  margin: 16px;
}
</style>
<style scoped>
.col-inline {
  display: inline-flex;
}

.refresh-btn {
  height: 40px;
  margin-left: 25px;
}

.input-datepicker {
  height: 90%;
  width: 150px;
}

.select-page {
  margin-top: -5px;
  margin-left: 5px;
  width: 70px;
}

.download-div {
  display: inline-grid;
  margin-top: -10px;
  margin-bottom: -10px;
  cursor: pointer;
}

.download-title {
  font-family: "Open sans";
  font-size: 10px;
  text-align: center;
  width: 50px;
}

.download-icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  margin-left: 15px;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIwAAACMCAYAAACuwEE+AAAAAXNSR0IArs4c6QAABWxJREFUeJzt3U9rHVUcxvFvpUhoF4oiFCMVaiKCCmJx5QtQkPoidOXCP+9AfQVGxIVuxa2LupOiLlQMUlNURG2biAvtpiJiEdH2upi5WJJM5jwzc875jXk+cGihNzO/3z1Pzu3knswFM7NcjtQuIKCngVPt37eBsxVrscBOApvAYtfYBE5UrMsCOgbssDcsy7ENHK9WnYWzQXdYlmOjWnUWznf0B+ZCteoslGPAdfoD8wdwS6Uaw/BVUmOR+LhD/3wd+u8Y0zgwJnFgTOLAmMSBMYkDYxIHxiQOjEkcGJM4MCZxYEziwJjEgTGJA2MSB8YkDoxJHBiTODAmcWBM4sCYxIExiQNjEgfGJA6MSRwYkzgwJnFgTOLAmMSBMYkDYxIHxiQOjEkcGJMczXz8x4DTpN+29DfgMvB+torm5QxwH3B74uOvAOeBL7JVlMFTwBb994w7aHxG2XvjptZVyirwuVDXfuM88ETBmmXHgLcY12Ste+NGCkzfPYPV8SawUqj2ZPfSTPBUTS7Ha4XqjxSYN4R6UsdFmjudh3AE+JTpm1wAXxbqIVJgvhHqUcYnherv9RJ5GlwAvxfqIVJgcj2XC+D5Qj10egD4i3wNlrr7dqTAfCXUo44/aa66Bhv7c5hngFtHHuMgH2Y8dlQfZTz2CvBsxuP3Oku+74YdmiuGEiKtMMfJcwGxHO8V6mNf33cUNXa8A9xVsI9IgYGm93eFupTx7ZjCxt47P/VJfDXxcdvAOeDnYeUMltpH6c8auBt4kvRL4pcTHze4j1KBif6hDu4jkd98NIkDYxIHxiQOjEkcGJM4MCZxYEziwJgk957eEs4AazQ/tIq4H3i5Lxdi1ldUzfdgVmk2WO0+1yb6fuAcfay2tUxRX6po74ntUavAvn2vv9CsOqmm7mOtraHrOLn2KzswHVL2vV4hPTRT9rHenrvvWDn2KzswHVL3vaauNFP10bey3Dxy7Fd2YEaeN3WlmaKP1JVlOXLsV3ZgOnwtnDtlpRnbh7KyLEeO/crZ52OuP4f5WHz8CZpfs1D+I5xqvT22euVzGPcrV1thhu577VpphvYxZGVZkG+/sl+SDjB0svYLzZA+pjz/VByYHlNNmtpHxLAM6aO4CAVOMXlKH1HDovZRRZQCx05i6uMjhwWhnmoiFThmMnM8tnRYEGqqJlqBQ0OTa5QMC0Jd1UQsMEpoSocFobZqohZYOzQ1woJQXzWRC6wVmlphQaixmugFrqG9ITh2KFsqcog+H/ELpNxKU3NlWQo/H+ELbOUOTYSwwAzmI3yBN8kVmihhgRnMR/gCd5k6NJHCAjOYj/AF7mOq0EQLC8xgPsIX2GFsaCKGBWYwH+ELPMDQS+7al84HCT8f4Qvsoa40UVeWpfDzEb7ABGvANfp7uEbssMAM5iN8gYkeBv6hu/6/gYeqVZcu/HyEL1DwIPAje2vfaf9tDrLPh2+7utdp4DngOvA2zQdVzUX2+XBg/l+yz8dcf5HNKnFgTOLAmMSBMYkDYxIHxiQOjEkcGJM4MCZxYEziwJjEgTGJA2MSB8YkDoxJHBiTODAmcWBM4sCYxIExiQNjEgfGJA6MSRwYkzgwJnFgTOLAmMSBMYkDYxIHxiQOjEkcGJM4MCY5Wug8rxQ6j2U29lZiW8AjUxRixWwBjw794rEvSRdGfr2VtzXmix2Yw2dUYMa+JN0JXAZuG3kcK+NXYL39c5CxK8xV4MWRx7ByXmBEWKb0Ael3ofaoM851zl4FJ4FL1H9SPPYfl4B7OmevkhXgdeAG9Z8gj2bcADbauQnrceAn6j9Zh33stHMxqZyfAXAKuL8dd2Q8j/3nKnAR+AHYrlyLmZnoXy8stDX6pnDnAAAAAElFTkSuQmCC");
}

.prev-icon {
  display: inline-block;
  width: 7.41px;
  height: 12px;
  margin-left: 33px;
  cursor: pointer;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDggMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03LjQxIDExLjA5TDIuODMgNi41TDcuNDEgMS45MUw2IDAuNUwwIDYuNUw2IDEyLjVMNy40MSAxMS4wOVoiIGZpbGw9IiNDMkM5RDEiLz4KPHBhdGggZD0iTTcuNDEgMTEuMDlMMi44MyA2LjVMNy40MSAxLjkxTDYgMC41TDAgNi41TDYgMTIuNUw3LjQxIDExLjA5WiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC4yNSIvPgo8L3N2Zz4K");
}

.next-icon {
  display: inline-block;
  width: 7.41px;
  height: 12px;
  margin-left: 33px;
  cursor: pointer;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDggMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjU4OTg0NCAxMS4zNEw1LjE2OTg0IDYuNzVMMC41ODk4NDQgMi4xNkwxLjk5OTg0IDAuNzVMNy45OTk4NCA2Ljc1TDEuOTk5ODQgMTIuNzVMMC41ODk4NDQgMTEuMzRaIiBmaWxsPSIjQzJDOUQxIi8+CjxwYXRoIGQ9Ik0wLjU4OTg0NCAxMS4zNEw1LjE2OTg0IDYuNzVMMC41ODk4NDQgMi4xNkwxLjk5OTg0IDAuNzVMNy45OTk4NCA2Ljc1TDEuOTk5ODQgMTIuNzVMMC41ODk4NDQgMTEuMzRaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjI1Ii8+Cjwvc3ZnPgo=");
}

.h-40-px {
  height: 40px;
  width: 150px;
}

.icon-inprocessing {
  position: absolute;
  margin: 5px 0px 0px 10px;
}

.text-inprocessing {
  margin-left: 55px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/admin/coupon/ImportHistory.vue